import { cloudFunctionsInstance } from 'config/axios'

export const SummarizationContentType = {
  SPEAKER_BIO: 'speakerBio',
  SESSION_SYNOPSIS: 'sessionSynopsis'
}

export const summarizeContent = async (text, type) => {
  const { data } = await cloudFunctionsInstance.post('/summarizeContent', { text, type })
  return data?.data?.summary
}
